import React from 'react';
import styled from 'styled-components';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import ICellProps from '../../../ICellProps';
import MapForm from '../../../../../../../MapForm';
import { TooltipHost } from 'office-ui-fabric-react';
import CoordsInput from 'views/components/UI/CoordsInput/CoordsInput';

interface IProps extends ICellProps {
  composite?: any;
  row?: any;
  config?: any;
  onValueChange?: (field: any, value: any) => void;
  readonly?: boolean;
  isCoordsArray?: boolean;
}

interface IState {
  isMapShowing: boolean;
  isShowInput: boolean;
}

const DataBlock = styled.div`
  padding: 0 10px;
  i {
    cursor: pointer;
    color: #003a72;
  }
`;

const DEFAULT_COORDS = '000.00000;000.000000';

const computeCoords = ({ row, composite, isCoordsArray }: IProps): string => {
  if (isCoordsArray) {
    const [lat, lon] = row.coords ?? [];
    return lat != null && lon != null ? `${lat};${lon}` : DEFAULT_COORDS;
  }

  const latVal = row?.[composite.lat];
  const lonVal = row?.[composite.lon];

  if (latVal == null) return DEFAULT_COORDS;

  const safeLon =
    lonVal == null || lonVal === '' ? '000.00000' : String(lonVal);

  return `${latVal};${safeLon}`;
};

class Point extends React.Component<IProps, IState> {
  state = {
    isMapShowing: false,
    isShowInput: false,
  };

  onShowEditDlg = (): void => {
    this.setState({ isMapShowing: true });
  };

  onCloseEditDlg = (): void => {
    this.setState({ isMapShowing: false });
  };

  getConnectedField = (fieldName: string): any => {
    const { config } = this.props;
    return config.fields.find((fl: any) => fl.name === fieldName);
  };

  onAccept = (data: any): void => {
    //this.props.onChange(data);
    const { composite } = this.props;

    if (this.props.isCoordsArray) {
      this.props.onValueChange &&
        this.props.onValueChange(this.getConnectedField(composite.field), [data.lat, data.lon]);
    } else {
      this.props.onValueChange &&
        this.props.onValueChange(this.getConnectedField(composite.lat), data.lat || '');
      this.props.onValueChange &&
        this.props.onValueChange(this.getConnectedField(composite.lon), data.lon % 360 || '');
    }

    this.setState({ 
      isMapShowing: false,
      isShowInput: false,
     });
  };

  render() {
    const { composite, row, readonly } = this.props;

    const coords = computeCoords(this.props);
    
    return (
      <DataBlock>
        {
          <CoordsInput onChange={(value: any) => {
            const coords = value.split(';')

            this.onAccept({
              lat: coords[0] || '',
              lon: coords[1] || ''
            });
          }} value={coords} editable accuracy={composite.accuracy} />
        }
        <TooltipHost content="Недостаточно прав доступа" id={'showMap'} calloutProps={{ gapSpace: 0 }} hidden={!readonly}>
          <Icon iconName={'Edit'} onClick={!readonly ? this.onShowEditDlg : undefined} />
        </TooltipHost>
        {this.state.isMapShowing && (
          <MapForm
            {...(this.props as any)}
            point={
              (Number(coords.split(';')[0]) && Number(coords.split(';')[1]) &&
              {
                lat: coords.split(';')[0],
                lon: coords.split(';')[1],
              }) || undefined
            }
            onClose={this.onCloseEditDlg}
            onAccept={this.onAccept}
            value={this.props.isCoordsArray ? undefined : this.props.value}
          />
        )}
      </DataBlock>
    );
  }
}

export default Point;
